import React from "react";

import Slider from "react-slick";

const Testimonials = () => {
  const reviews = [
    {
      name: "Tommy Chan",
      position: "Coworker in Social Welfare Department",
      // src: "images/testimonial/client-sm-1.jpg",
      desc: " “I've had the pleasure of working alongside Dennis for 2 years, and it's been an incredible experience. Dennis is not just a talented programmer but also an exceptional team player. His dedication to the success of our projects is unwavering, and he consistently bring innovative solutions to the table.”",
    },
    {
      name: "Alice Wong",
      position: "Project Manager in Social Welfare Department",
      // src: "images/testimonial/client-sm-2.jpg",
      desc: " “Dennis has consistently demonstrated exceptional programming skills during their time at Social Welfare Department. He adapt quickly to new technologies, excel in problem-solving, and maintain a strong commitment to clean, high-quality code. Dennis is not only an excellent team player but also a go-to resource for complex technical challenges. His contributions have greatly enhanced our projects, and I anticipate continued success in their role.”",
    },
    {
      name: "Taylor Lo",
      position: "Schoolmate from University ",
      // src: "images/testimonial/client-sm-3.jpg",
      desc: "“Dennis was not only a standout programmer during our time at university but also a wonderful friend. His passion for coding was infectious, and his willingness to help others made them a standout student. Dennis's commitment to staying at the forefront of technology ensures a bright future in the programming field, and I'm excited to see where his journey takes him.”",
    },
  ];

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );

  var settings = {
    dots: true,
    arrows: true,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4500,
  };

  return (
    <section id="testimonial" className="section bg-secondary">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeIn">
          <span className="bg-primary text-dark px-2">Coworker Speak</span>
        </p>
        <h2 className="text-10 fw-600 text-white text-center mb-5 wow fadeIn">
          What Some of my previous Colleague and Supervisor Say
        </h2>
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-9 mx-auto wow fadeInUp">
            <Slider {...settings}>
              {reviews.length > 0 &&
                reviews.map((review, index) => (
                  <div className="item text-center px-5" key={index}>
                    {" "}
                    <span className="text-9 text-primary">
                      <i className="fa fa-quote-start" />
                    </span>
                    <p className="text-5 text-white">{review.desc}</p>
                    {/* <img
                      className="img-fluid d-inline-block w-auto rounded-circle shadow"
                      src={review.src}
                      alt={review.name}
                    />{" "} */}
                    <strong className="d-block text-3 fw-600 text-white">
                      {review.name}
                    </strong>{" "}
                    <span className="text-light">{review.position}</span>{" "}
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
